// API Configuration
export const API_BASE_URL = `${
  (typeof window !== 'undefined' && window.kipara && window.kipara.apiBase != null)
    ? window.kipara.apiBase
    : (process.env.REACT_APP_BASE_URL || '')
}/api/`;

// Authentication Token Key
export const AUTH_TOKEN_KEY = 'user_token';

// Date Format
export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const DEFAULT_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';

// Pagination
export const DEFAULT_PAGE_SIZE = 10;

// Status Colors
export const STATUS_COLORS = {
  scheduled: {
    bg: 'bg-blue-100',
    text: 'text-blue-800',
    hover: 'hover:bg-blue-200'
  },
  in_progress: {
    bg: 'bg-yellow-100',
    text: 'text-yellow-800',
    hover: 'hover:bg-yellow-200'
  },
  completed: {
    bg: 'bg-green-100',
    text: 'text-green-800',
    hover: 'hover:bg-green-200'
  },
  cancelled: {
    bg: 'bg-red-100',
    text: 'text-red-800',
    hover: 'hover:bg-red-200'
  }
};
